import * as React from 'react'
import { helperPlaceholderSVG } from '../helpers.mod'

export const updatesBlock = () => {
  return (
    <section className="block block--related block--updates ls-block-spacing">
      <div className="block__inner ls-container">
        <header className="block__header">
          <h2 className="block__title title--l">Updates</h2>
        </header>
        <div className="block__content">
          <ul className="block__list grid">
            <li className="grid__item">
              <article className="grid__article">
                <div className="grid__content">
                  <header className="grid__header">
                    <h3 className="grid__title title--m">
                      Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                      Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                    </h3>
                    <a className="grid__link link">Read more</a>
                  </header>
                </div>
                <div className="grid__wrap">
                  <div className="grid__visual fit-object">
                    <img
                      loading="lazy"
                      className="grid__image"
                      src={helperPlaceholderSVG({
                        shape: { width: 1400, height: 875, radius: '0', color: '#e8e8e8' },
                        text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                      })}
                      alt="Placeholder"
                    />
                  </div>
                </div>
              </article>
            </li>
            <li className="grid__item">
              <article className="grid__article">
                <div className="grid__content">
                  <header className="grid__header">
                    <h3 className="grid__title title--s">
                      Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                      Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                    </h3>
                    <a className="grid__link"></a>
                  </header>
                  <time className="grid__date text--s" dateTime="27 november 2020">
                    27 novembre 2020
                  </time>
                </div>
                <div className="grid__wrap">
                  <div className="grid__tags tags">
                    <span className="grid__tag tag tag--m">Nibh</span>
                    <span className="grid__tag tag tag--m">Magna Fermentum Ultricies</span>
                  </div>
                  <div className="grid__visual fit-object">
                    <img
                      loading="lazy"
                      className="grid__image"
                      src={helperPlaceholderSVG({
                        shape: { width: 1400, height: 875, radius: '0', color: '#e8e8e8' },
                        text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                      })}
                      alt="Placeholder"
                    />
                  </div>
                </div>
              </article>
            </li>
            <li className="grid__item">
              <article className="grid__article">
                <div className="grid__content">
                  <header className="grid__header">
                    <h3 className="grid__title title--s">
                      Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                      Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                    </h3>
                    <a className="grid__link"></a>
                  </header>
                  <time className="grid__date text--s" dateTime="27 november 2020">
                    27 novembre 2020
                  </time>
                </div>
                <div className="grid__wrap">
                  <div className="grid__tags tags">
                    <span className="grid__tag tag tag--m">Partnership</span>
                  </div>
                  <div className="grid__visual fit-object">
                    <img
                      loading="lazy"
                      className="grid__image"
                      src={helperPlaceholderSVG({
                        shape: { width: 1400, height: 875, radius: '0', color: '#e8e8e8' },
                        text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                      })}
                      alt="Placeholder"
                    />
                  </div>
                </div>
              </article>
            </li>
            <li className="grid__item">
              <article className="grid__article">
                <div className="grid__content">
                  <header className="grid__header">
                    <h3 className="grid__title title--s">
                      Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                      Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                    </h3>
                    <a className="grid__link"></a>
                  </header>
                  <time className="grid__date text--s" dateTime="27 november 2020">
                    27 novembre 2020
                  </time>
                </div>
                <div className="grid__wrap">
                  <div className="grid__tags tags">
                    <span className="grid__tag tag tag--m">Tristique</span>
                    <span className="grid__tag tag tag--m">Tristique Vulputate</span>
                  </div>
                  <div className="grid__visual fit-object">
                    <img
                      loading="lazy"
                      className="grid__image"
                      src={helperPlaceholderSVG({
                        shape: { width: 1400, height: 875, radius: '0', color: '#e8e8e8' },
                        text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                      })}
                      alt="Placeholder"
                    />
                  </div>
                </div>
              </article>
            </li>
          </ul>
        </div>
        <footer className="block__footer">
          <a className="link" href="/">
            All news
          </a>
        </footer>
      </div>
    </section>
  )
}

export const updatesOverview = () => {
  return (
    <section className="block block--updates-overview ls-block-spacing">
      <div className="block__inner ls-container">
        <div className="block__content">
          <ul className="block__list grid">
            <li className="grid__item">
              <article className="grid__article">
                <div className="grid__content">
                  <header className="grid__header">
                    <h3 className="grid__title title--s">
                      Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                      Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                    </h3>
                    <a className="grid__link"></a>
                  </header>
                  <time className="grid__date text--s" dateTime="27 november 2020">
                    27 novembre 2020
                  </time>
                </div>
                <div className="grid__wrap">
                  <div className="grid__tags tags">
                    <span className="grid__tag tag tag--m">Nibh</span>
                    <span className="grid__tag tag tag--m">Magna Fermentum Ultricies</span>
                  </div>
                  <div className="grid__visual fit-object">
                    <img
                      loading="lazy"
                      className="grid__image"
                      src={helperPlaceholderSVG({
                        shape: { width: 1400, height: 875, radius: '0', color: '#e8e8e8' },
                        text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                      })}
                      alt="Placeholder"
                    />
                  </div>
                </div>
              </article>
            </li>
            <li className="grid__item">
              <article className="grid__article">
                <div className="grid__content">
                  <header className="grid__header">
                    <h3 className="grid__title title--s">
                      Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                      Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                    </h3>
                    <a className="grid__link"></a>
                  </header>
                  <time className="grid__date text--s" dateTime="27 november 2020">
                    27 novembre 2020
                  </time>
                </div>
                <div className="grid__wrap">
                  <div className="grid__tags tags">
                    <span className="grid__tag tag tag--m">Nibh</span>
                    <span className="grid__tag tag tag--m">Magna Fermentum Ultricies</span>
                  </div>
                  <div className="grid__visual fit-object">
                    <img
                      loading="lazy"
                      className="grid__image"
                      src={helperPlaceholderSVG({
                        shape: { width: 1400, height: 875, radius: '0', color: '#e8e8e8' },
                        text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                      })}
                      alt="Placeholder"
                    />
                  </div>
                </div>
              </article>
            </li>
            <li className="grid__item">
              <article className="grid__article">
                <div className="grid__content">
                  <header className="grid__header">
                    <h3 className="grid__title title--s">
                      Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                      Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                    </h3>
                    <a className="grid__link"></a>
                  </header>
                  <time className="grid__date text--s" dateTime="27 november 2020">
                    27 novembre 2020
                  </time>
                </div>
                <div className="grid__wrap">
                  <div className="grid__tags tags">
                    <span className="grid__tag tag tag--m">Partnership</span>
                  </div>
                  <div className="grid__visual fit-object">
                    <img
                      loading="lazy"
                      className="grid__image"
                      src={helperPlaceholderSVG({
                        shape: { width: 1400, height: 875, radius: '0', color: '#e8e8e8' },
                        text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                      })}
                      alt="Placeholder"
                    />
                  </div>
                </div>
              </article>
            </li>
            <li className="grid__item">
              <article className="grid__article">
                <div className="grid__content">
                  <header className="grid__header">
                    <h3 className="grid__title title--s">
                      Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                      Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                    </h3>
                    <a className="grid__link"></a>
                  </header>
                  <time className="grid__date text--s" dateTime="27 november 2020">
                    27 novembre 2020
                  </time>
                </div>
                <div className="grid__wrap">
                  <div className="grid__tags tags">
                    <span className="grid__tag tag tag--m">Tristique</span>
                    <span className="grid__tag tag tag--m">Tristique Vulputate</span>
                  </div>
                  <div className="grid__visual fit-object">
                    <img
                      loading="lazy"
                      className="grid__image"
                      src={helperPlaceholderSVG({
                        shape: { width: 1400, height: 875, radius: '0', color: '#e8e8e8' },
                        text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                      })}
                      alt="Placeholder"
                    />
                  </div>
                </div>
              </article>
            </li>
            <li className="grid__item">
              <article className="grid__article">
                <div className="grid__content">
                  <header className="grid__header">
                    <h3 className="grid__title title--s">
                      Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit.
                      Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                    </h3>
                    <a className="grid__link"></a>
                  </header>
                  <time className="grid__date text--s" dateTime="27 november 2020">
                    27 novembre 2020
                  </time>
                </div>
                <div className="grid__wrap">
                  <div className="grid__tags tags">
                    <span className="grid__tag tag tag--m">Nibh</span>
                    <span className="grid__tag tag tag--m">Magna Fermentum Ultricies</span>
                  </div>
                  <div className="grid__visual fit-object">
                    <img
                      loading="lazy"
                      className="grid__image"
                      src={helperPlaceholderSVG({
                        shape: { width: 1400, height: 875, radius: '0', color: '#e8e8e8' },
                        text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
                      })}
                      alt="Placeholder"
                    />
                  </div>
                </div>
              </article>
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}

export const filtersBlock = () => {
  return (
    <section className="filters ls-container">
      <div className="filters__inner">
        <header className="filters__header">
          <h2 className="filters__title title--s">Filter updates by subject</h2>
        </header>
        <div className="filters__content">
          <ul className="filters__list tags">
            <li className="tags__item">
              <a className="tag tag--m" href="/styleguide">
                Nibh
              </a>
            </li>
            <li className="tags__item">
              <a className="tag tag--m" href="/styleguide">
                Parturient Cras Elit
              </a>
            </li>
            <li className="tags__item">
              <a className="tag tag--m" href="/styleguide">
                Parturient
              </a>
            </li>
            <li className="tags__item">
              <a className="tag tag--m" href="/styleguide">
                Cras Elit
              </a>
            </li>
            <li className="tags__item">
              <a className="tag tag--m" href="/styleguide">
                Adipiscing
              </a>
            </li>
            <li className="tags__item">
              <a className="tag tag--m" href="/styleguide">
                Fuscet
              </a>
            </li>
            <li className="tags__item">
              <a className="tag tag--m" href="/styleguide">
                Risus Etiam
              </a>
            </li>
            <li className="tags__item">
              <a className="tag tag--m" href="/styleguide">
                Nibh
              </a>
            </li>
            <li className="tags__item">
              <a className="tag tag--m" href="/styleguide">
                Parturient Cras Elit
              </a>
            </li>
            <li className="tags__item">
              <a className="tag tag--m" href="/styleguide">
                Parturient
              </a>
            </li>
            <li className="tags__item">
              <a className="tag tag--m" href="/styleguide">
                Cras Elit
              </a>
            </li>
            <li className="tags__item">
              <a className="tag tag--m" href="/styleguide">
                Adipiscing
              </a>
            </li>
            <li className="tags__item">
              <a className="tag tag--m" href="/styleguide">
                Fuscet
              </a>
            </li>
            <li className="tags__item">
              <a className="tag tag--m" href="/styleguide">
                Risus Etiam
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}

export const searchBlock = () => {
  return (
    <section className="block block--search  ls-block-spacing">
      <div className="block__inner ls-container">
        <form className="block__form" role="search">
          <label className="block__label tag--m">
            Keyword<span className="sr-text">search</span>
          </label>
          <div className="block__wrap">
            <input className="block__input" type="search" id="a11y-search" name="a11y-search" />
            <button className="block__button" type="submit">
              Find updates
            </button>
          </div>
        </form>
      </div>
    </section>
  )
}

export const searchDropdownBlock = () => {
  return (
    <section className="block block--search block--dropdown ls-block-spacing">
      <div className="block__inner ls-container">
        <form className="block__form" role="search">
          <div className="block__grid">
            <div className="block__column">
              <label className="block__label tag--m">
                Keyword<span className="sr-text">Search</span>
              </label>
              <input className="block__input" type="search" id="a11y-search" name="a11y-search" />
            </div>
            <div className="block__column">
              <label className="block__label tag--m" htmlFor="specialism">
                Type of specialism<span className="sr-text">Select a Type of specialism</span>
              </label>
              <select className="block__dropdown" name="specialism" id="specialism">
                <option>All Consectetur Magna</option>
                <option>Consectetur Ullamcorper</option>
                <option>Magna</option>
              </select>
            </div>
          </div>
          <button className="block__button" type="submit">
            Find vacancies
          </button>
        </form>
      </div>
    </section>
  )
}

export const resultsBlock = () => {
  return (
    <section className="block block--results ls-block-spacing">
      <div className="block__inner ls-container">
        <header className="block__header">
          <h2 className="block__title title--l">Results</h2>
        </header>
        <div className="block__content">
          <ul className="block__list blocklist">
            <li className=" blocklist__item">
              <a className="blocklist__link" href="/styleguide">
                <h3 className="blocklist__title title--m">Transport Coordinator</h3>
                <p className="blocklist__subtitle">
                  Are you looking for a challenging logistics position in a dynamic international working environment in
                  which you take responsibility for the operational logistics process for our projects and ships? Then
                  please continue reading!
                </p>
                <p className="blocklist__label tag--m">
                  Engineering & Technology, Project Management & Operations, Office Rotterdam
                </p>
              </a>
            </li>
            <li className=" blocklist__item">
              <a className="blocklist__link" href="/styleguide">
                <h3 className="blocklist__title title--m">Internship Dredging Projects</h3>
                <p className="blocklist__subtitle">
                  Are you looking for a challenging logistics position in a dynamic{' '}
                </p>
                <p className="blocklist__label tag--m">Engineering & Technology</p>
              </a>
            </li>
            <li className=" blocklist__item">
              <a className="blocklist__link" href="/styleguide">
                <h3 className="blocklist__title title--m">Transport Coordinator</h3>
                <p className="blocklist__subtitle">
                  As an intern you will work under the guidance of an experienced coach in the dredging project
                  environment.
                </p>
                <p className="blocklist__label tag--m">
                  Internship & Graduation, Project Management & Operations Projects Netherlands
                </p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}

export const resultsDownloadBlock = () => {
  return (
    <section className="block block--download block--download-results ls-block-spacing">
      <div className="block__inner ls-container">
        <header className="block__header">
          <h2 className="block__title title--l">Related Download</h2>
        </header>
        <div className="block__content">
          <ul className="block__list blocklist">
            <li className=" blocklist__item">
              <a className="blocklist__link" href="/styleguide">
                <h3 className="blocklist__title title--m">Transport Coordinator</h3>
                <p className="blocklist__subtitle">
                  Are you looking for a challenging logistics position in a dynamic international working environment in
                  which you take responsibility for the operational logistics process for our projects and ships? Then
                  please continue reading!
                </p>
                <p className="blocklist__fauxlink text--l">Download now</p>
              </a>
            </li>
            <li className=" blocklist__item">
              <a className="blocklist__link" href="/styleguide">
                <h3 className="blocklist__title title--m">Internship Dredging Projects</h3>
                <p className="blocklist__subtitle">
                  Are you looking for a challenging logistics position in a dynamic{' '}
                </p>
                <p className="blocklist__fauxlink text--l">Download now</p>
              </a>
            </li>
            <li className=" blocklist__item">
              <a className="blocklist__link" href="/styleguide">
                <h3 className="blocklist__title title--m">Transport Coordinator</h3>
                <p className="blocklist__subtitle">
                  As an intern you will work under the guidance of an experienced coach in the dredging project
                  environment.
                </p>
                <p className="blocklist__fauxlink text--l">Download now</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}

export const pressContactBlock = (hasImage: boolean) => {
  return (
    <section className={`block block--press${hasImage == true ? ' has-image' : ''} grid--spacing ls-block-spacing`}>
      <div className="block__inner ls-container">
        <header className="block__header">
          <h2 className="block__title title--l">Press contact</h2>
        </header>
        <div className="block__content">
          <p className="block__name">Robert de Bruin</p>
          <div className="block__column">
            <ul className="block__list">
              <li className="block__item block__item--bottom">Contact media relations</li>
              <li className="block__item block__item--icon">
                <svg className="block__icon" height="22" width="22">
                  <use xlinkHref="#icon--phone" />
                </svg>
                <a href="tel:0031 88 8268234">0031 88 8268234</a>
              </li>
              <li className="block__item block__item--icon">
                <svg className="block__icon" height="22" width="22">
                  <use xlinkHref="#icon--phone" />
                </svg>
                <a href="tel:0031 88 8268234">0031 88 8268234</a>
              </li>
              <li className="block__item block__item--icon">
                <svg className="block__icon" height="18" width="22">
                  <use xlinkHref="#icon--mail" />
                </svg>
                <a href="mailto:robert.debruin@vanoord.com">robert.debruin@vanoord.com</a>
              </li>
            </ul>
          </div>
          <div className="block__column">
            <p className="block__text">
              Robert de Bruin deals with all media enquiries relating to Van Oord's corporate and international
              activities. For non press related questions we kindly redirect you to our <a href="/">contact form.</a>
            </p>
          </div>
        </div>
        {hasImage == true ? (
          <div className="block__visual fit-object">
            <img
              loading="lazy"
              src={helperPlaceholderSVG({
                shape: { width: 640, height: 640, radius: '0', color: '#e8e8e8' },
                text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' }
              })}
              width="640"
              height="640"
              className="block__image"
              alt="Donec ullamcorper nulla non metus auctor fringilla"
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </section>
  )
}
